<div class="w-full bg-white rounded-md px-2 py-1">
    <ng-content select="[filters]"></ng-content>
</div>

<!-- Toolbar: selection banner OR projected toolbar content -->
<ng-container *ngIf="selected_ids_count > 0 && !hide_bulk_toolbar; else toolbarSlot">
    <div class="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200">
        <div class="flex items-center gap-3">
            <button (click)="clear_selection()" class="flex items-center justify-center w-6 h-6 rounded hover:bg-gray-100 transition-colors">
                <i class="bx bx-x text-2xl text-gray-600"></i>
            </button>
            <span class="text-sm font-medium leading-none tracking-normal text-[#212121]">
                {{ selected_ids_count < 10 ? '0' + selected_ids_count : selected_ids_count }}
                {{ selected_ids_count === 1 ? itemName : (itemName | plural) }} Selected
            </span>
        </div>
        <div class="flex items-center gap-2">
            <!-- <app-button *ngIf="bulk_disable && (disable_permission === undefined || disable_permission)" color="bg-white border-primary text-primary" label="Disable" (click)="disable_selected_rows()"></app-button> -->
            <app-button *ngIf="bulk_delete && (delete_permission === undefined || delete_permission)" color="bg-[#E6393E] text-white" icon="bx bx-trash" label="Delete" (click)="delete_selected_rows()"></app-button>
        </div>
    </div> 
</ng-container>
<ng-template #toolbarSlot>
    <ng-content select="[toolbar]"></ng-content>
</ng-template>

<div class="grid grid-rows-[1fr_auto] min-h-[500px] bg-white" [style.height]="height">
    <ag-grid-angular (cellValueChanged)="cell_changed($event)" [defaultColDef]="defaultColDef" (sortChanged)="onSortChanged($event)" [rowSelection]="rowSelection" (filterChanged)="onFilterChanged()" (selectionChanged)="onSelectionChanged($event)" #grid rowSelection="multiple" (gridReady)="grid_ready($event)" class=" w-full px-4" [theme]="theme" [rowData]="list?.data || []" [columnDefs]="effectiveColDefs" [overlayNoRowsTemplate]="overlayNoRowsTemplate" [getRowStyle]="internalGetRowStyle" [headerHeight]="headerHeight" [rowHeight]="rowHeight" />
    <div class="flex justify-end items-center gap-6 px-6 py-3 bg-white">
        <div class="flex items-center gap-3 text-sm text-[#333333]">
            <span>Rows per page</span>
            <div class="relative">
                <select [(ngModel)]="pagination.page_size" (ngModelChange)="change_page_size()"
                    class="appearance-none text-primary text-sm font-semibold bg-transparent border-b-2 border-primary focus:outline-none cursor-pointer pr-5 pb-1">
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                    <option [value]="20">20</option>
                    <option [value]="30">30</option>
                    <option [value]="50">50</option>
                </select>
                <div class="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                    <i class="bx bx-chevron-down text-primary text-base"></i>
                </div>
            </div>
        </div>
        <span class="text-sm text-[#333333]">{{showingFrom}}-{{showingTo}} of {{list?.count || 0}}</span>
        <div class="flex items-center gap-1">
            <button (click)="change_pagination('previous')" [disabled]="pagination.page === 1"
                class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <i class="bx bx-chevron-left text-xl text-[#555]"></i>
            </button>
            <button (click)="change_pagination('next')" [disabled]="pagination.page === total_pages || !list?.data?.length"
                class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <i class="bx bx-chevron-right text-xl text-[#555]"></i>
            </button>
        </div>
    </div>
</div>

<app-confirmation-popup #bulk_delete_confirmation [label]="'Delete ' + (itemName | plural)   + '?'" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="confirm_bulk_delete()" (close_modal_clicked)="bulk_delete_confirmation.close()">
    Are you sure you want to Permanently delete the {{selected_ids_count}} record ? This cannot be undone
</app-confirmation-popup>

<app-confirmation-popup #bulk_disable_confirmation [label]="'Disable ' + (itemName | plural) + '?'" [disabled_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="confirm_bulk_disable()" (close_modal_clicked)="bulk_disable_confirmation.close()">
    Are you sure you want to Disable the {{selected_ids_count}} {{ selected_ids_count === 1 ? itemName : (itemName | plural) }} ?
</app-confirmation-popup>